<script lang="ts" setup>
    import CommonBanner from '~/components/common/Banner.vue';
    import { RECOVERY_EMAIL_RECOMMENDED, RECOVERY_EMAIL_UNVERIFIED } from '~/constants/banner-alerts';

    const auth = useAuth();
    const route = useRoute();

    const shouldBannerBeVisible = computed(() => {
        return auth.user && auth.account && !route.meta.documentPrep && !route.meta.session && !route.meta.onboarding;
    });

    const isSecondaryEmailSet = computed(() => {
        return auth.user?.secondary_email && auth.user?.secondary_email !== '';
    });

    const isSecondaryEmailVerified = computed(() => {
        return auth.user?.secondary_email_verified_at && auth.user?.secondary_email_verified_at !== null;
    });
</script>

<template>
    <CommonBanner :z-index="0" class="p-2" v-if="shouldBannerBeVisible && !isSecondaryEmailSet && !isSecondaryEmailVerified" :id="RECOVERY_EMAIL_RECOMMENDED" :data-test-id="RECOVERY_EMAIL_RECOMMENDED" dismissable :fixed-top="false" bg-color="bg-warning">
        <NuxtLink class="text-white underline" to="/user/edit?selected-tab=tab3">
            <Icon name="heroicons-solid:exclamation-triangle" />
            Avoid losing access to your account by adding a recovery email.
        </NuxtLink>
    </CommonBanner>
    <CommonBanner :z-index="0" class="p-2" v-if="shouldBannerBeVisible && !isSecondaryEmailVerified && isSecondaryEmailSet" :id="RECOVERY_EMAIL_UNVERIFIED" :data-test-id="RECOVERY_EMAIL_UNVERIFIED" dismissable :fixed-top="false" bg-color="bg-warning">
        <NuxtLink class="text-white underline" to="/user/edit?selected-tab=tab3">
            <Icon name="heroicons-solid:exclamation-triangle" />
            Your recovery email is not verified. Verify it to avoid losing access to your user account.
        </NuxtLink>
    </CommonBanner>
</template>
